import ChatConversation from "./SVG/conversation-chat-1.svg?react";

const ChatConversationIcon = () => {
  return <ChatConversation />;
};

export default ChatConversationIcon;
